import { FaHistory, FaTree, FaLandmark, FaHeart } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaHistory />, // Historia sięgająca 1810 roku
        title: 'Lat Historii',
        count: '215',
    },
    {
        id: 2,
        icon: <FaTree />, // Bogactwo starodrzewu w parku
        title: 'Zabytkowych Drzew',
        count: '150', // Wartość przykładowa - do doprecyzowania po inwentaryzacji
    },
    {
        id: 3,
        icon: <FaLandmark />, // Data powstania głównego murowanego dworu
        title: 'Rok Budowy Dworu',
        count: '1850',
    },
    {
        id: 4,
        icon: <FaHeart />, // Społeczność/Wspierający misję ocalenia
        title: 'Wspierających Misję',
        count: '500', // Wartość pokazująca zaangażowanie lokalne
    },
];

export default counter;